module.exports = __webpack_public_path__ + "img/Pac-icon.8e65d7e5.svg";